<template>
  <div class="card mt-0">
    <div class="card-header">
      <h2>Contact Details</h2>
    </div>
    <div class="card-body">
      <ContactDetailsListRow
        :detailList="detailsByType(0)"
        :type="'email'"
        ref="row0"
        @save="saveContactDetail"
        @delete="deleteContactDetail"
      />

      <ContactDetailsListRow
        :detailList="detailsByType(1)"
        :type="'phone'"
        ref="row1"
        @save="saveContactDetail"
        @delete="deleteContactDetail"
      />

      <ContactDetailsListRow
        :detailList="detailsByType(2)"
        :type="'url'"
        ref="row2"
        @save="saveContactDetail"
        @delete="deleteContactDetail"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import ContactDetailsListRow from "./ContactDetailsListRow";

export default {
  props: ["entityType", "entityId"],

  components: {
    ContactDetailsListRow
  },

  data() {
    return {
      // A map of detailId => detail
      details: {},
      types: {
        email: 0,
        phone: 1,
        url: 2,
      }
    };
  },
  methods: {
    loadContactDetails() {
      this.details = {};
      axios.get(`/contact-details/get/${this.entityType}/${this.entityId}/`).then(response => {
        response.data.forEach(detail => {
          Vue.set(this.details, detail.id, detail);
        });
      })
    },
    saveContactDetail(detail) {
      const isNew = detail.id === 'new';
      let data = {
        type: detail.type,
        value: detail.value,
      };
      if (!isNew) {
        data.id = detail.id;
      }
      axios({
        method: isNew ? 'post' : 'put',
        url: `/contact-details/${(isNew ? 'add' : 'edit')}/${this.entityType}/${this.entityId}`,
        data: data
      }).then(response => {
        const savedDetail = response.data;
        Vue.set(this.details, savedDetail.id, savedDetail);
        this.$refs['row' + detail.type].cancelEdit();
      });
    },
    deleteContactDetail(detail) {
      if (!window.confirm("Are you sure you want to delete this contact detail?")) {
        return;
      }
      axios
        .delete(`/contact-details/delete/${this.entityType}/${this.entityId}/${detail.id}`)
        .then(response => {
          Vue.delete(this.details, detail.id);
          this.$refs['row' + detail.type].cancelEdit();
        });
    }
  },

  created() {
    this.loadContactDetails();
  },

  computed: {
    detailsByType() {
      return (type) => {
        return Object.values(this.details).filter(detail => {
          return detail.type === type;
        });
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// assets/js/components/ContactDetailsList.vue